export default class ColorsUtils {
     static convertHexToRgb(hex) {
        const result = /^#(?<a>[a-f\d]{2})?(?<r>[a-f\d]{2})(?<g>[a-f\d]{2})(?<b>[a-f\d]{2})$/i.exec(hex);
        if( result && !result.groups["a"])
            result.groups["a"] = "ff";

        return result ? {
            a: parseFloat((parseInt(result.groups["a"], 16) / 255).toFixed(2)),
            r: parseInt(result.groups["r"], 16),
            g: parseInt(result.groups["g"], 16),
            b: parseInt(result.groups["b"], 16)
        } : null;
    }
}